var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prikaz-diagrama"},[_c('span',{staticClass:"oblika-diagrama"},[_vm._v(_vm._s(_vm.skupaj)+" GB")]),_vm._v(" "),(_vm.podatki !== null)?_c('diagram-torta',{attrs:{"chart-data":_vm.podatki}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5dbd46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Poraba/PorabaHramba/KomponentaDiagramPorabe.vue
// module id = UjN9
// module chunks = 3